import React, { Component } from 'react';
import { connect } from 'react-redux';

import { StarRating } from '../shared';

import { getIcon } from '../../util/icons';

class ReviewAndSubmitSprintModal extends Component{

  state = {
    rating: 3,
  }

  componentWillMount(){
    this.hide = this.hide.bind(this);
    this.confirm = this.confirm.bind(this);
    this.secondaryAction = this.secondaryAction.bind(this);
  }

  hide(){
    if(!this.props.confirming){
      this.props.hide();
    }
  }
  confirm(){
    if(!this.props.confirming){
      this.props.onConfirm(this.state.rating);
    }
  }
  secondaryAction(){
    if(!this.props.confirming){
      this.props.onSecondaryAction();
    }
  }

  getConfirmButtonText(){

    const { confirming, confirmText, confirmingText } = this.props;

    if(confirming){
      if(confirmingText){
        return confirmingText;
      }
      else if(confirmText){
        return confirmText || 'OK';
      }
    }
    else{
      return confirmText || 'OK';
    }
  }

  changeRating(rating){
    this.setState({
      rating
    });
  }

  getStarRatingExplanations(){
    if(this.props.reviewingOwnSprint){
      return [
        'I need to make significant improvement going forward.',
        'Some progress this week, but I really need to step it up.',
        'Good progress, but definitely short of expectations',
        'Great progress, but room for improvement',
        'Great progress, meeting expectations',
      ]
    }
    else{
      return [
        'Needs to make significant improvement going forward.',
        'Some progress this week, but really needs to step it up.',
        'Good progress, but definitely short of expectations',
        'Great progress, but room for improvement',
        'Great progress, meeting expectations',
      ]
    }
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { confirming, confirmText, reviewingOwnSprint } = this.props;

    return (
      <div className="modal review-and-submit-sprint">
        <div className="modal-container">
          <div className="close-icon" onClick={this.hide}>X</div>
          <div className="modal-content">
            <div className="message-icon">{getIcon('rate')}</div>
            {reviewingOwnSprint &&
              <p>Please rate your performance this week...</p>
            }
            {!reviewingOwnSprint &&
              <p>How did they do</p>
            }
            <StarRating
              maxRating={5}
              currentRating={this.state.rating}
              updateRating={rating => { this.setState({ rating }) }}
              ratingExplanations={this.getStarRatingExplanations()}
              />
          </div>
          <div className="modal-actions">
            <button disabled={confirming} onClick={this.confirm} className="button primary">{this.getConfirmButtonText()}</button>
            <button disabled={confirming} onClick={this.hide} className="button grey-outline">Cancel</button>
          </div>
        </div>
      </div>
    )
  }
}

export default ReviewAndSubmitSprintModal;



// WEBPACK FOOTER //
// ./src/components/modals/reviewAndSubmitSprint.js